import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'bizflex-error-page-generic',
  standalone: true,
  imports: [],
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericComponent {
  @HostBinding('class') private readonly hostClass = 'text-center !mt-0';
}
